<capra-toast class="error-toast" type="error">
  <h4 class="toast-header">Dataset creation failed</h4>
  <p class="toast-text">
    You have exceeded the maximum number of local datasets (15) that can be exported by a notebook.
  </p>
</capra-toast>
